module.exports = __webpack_public_path__ + "img/halfdayicon.7ff09eef.svg";